import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { forwardRefWithAs as i, render as n } from '../utils/render.js';
var a = "div";

var s = function (e) {
  return e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e;
}(s || {});

var h = i(function (t, o) {
  var _t$features = t.features,
      e = _t$features === void 0 ? 1 : _t$features,
      r = _objectWithoutProperties(t, ["features"]),
      d = {
    ref: o,
    "aria-hidden": (e & 2) === 2 ? !0 : void 0,
    style: _objectSpread({
      position: "fixed",
      top: 1,
      left: 1,
      width: 1,
      height: 0,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      borderWidth: "0"
    }, (e & 4) === 4 && (e & 2) !== 2 && {
      display: "none"
    })
  };

  return n({
    ourProps: d,
    theirProps: r,
    slot: {},
    defaultTag: a,
    name: "Hidden"
  });
});
export { s as Features, h as Hidden };